// extracted by mini-css-extract-plugin
export default {"share":"share_share__9WkgN","field":"share_field__sSUPg","input":"share_input__S+aud","copy":"share_copy__g7p-7","success":"share_success__ScpmP"};